module.exports = __webpack_public_path__ + "static/img/pc_slogan.8aae233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/pc_slogan.png
// module id = 4tyU
// module chunks = 1 3